exports.components = {
  "component---src-components-common-file-js": () => import("./../../../src/components/CommonFile.js" /* webpackChunkName: "component---src-components-common-file-js" */),
  "component---src-components-faq-js": () => import("./../../../src/components/FAQ.js" /* webpackChunkName: "component---src-components-faq-js" */),
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */)
}

